import { Dashboard } from "./components/Dashboard";

export const HomeScreen = () => {
  return <Dashboard />;
};
